import { TQueueWhitelistItem } from './types';

export const applyQueueWhitelistToQueues = <TQueue extends { Arn: string; Description?: string }>({
  queues,
  queueWhitelist,
}: {
  queues: TQueue[];
  queueWhitelist?: TQueueWhitelistItem[];
}): TQueue[] => {
  if (!queueWhitelist?.length) {
    return queues.map((queue) => ({
      ...queue,
      Description: undefined,
    }));
  }

  const queuesByArn = new Map(queues.map((queue) => [queue.Arn, queue]));

  return queueWhitelist.flatMap((whitelistQueue) => {
    const queue = queuesByArn.get(whitelistQueue.queueArn);

    if (!queue) {
      return [];
    }

    return [
      {
        ...queue,
        Description: whitelistQueue.description || undefined,
      },
    ];
  });
};
